module.exports = __webpack_public_path__ + "img/like_ic.cf261135.svg";